/**
 * @file Commonly used easings.
 * inspired by https://gist.github.com/gre/1650294
 */

const easings = {
  linear(t: number) {
    return t
  },

  easeInQuad(t: number) {
    return t * t
  },

  easeOutQuad(t: number) {
    return t * (2 - t)
  },

  easeInOutQuad(t: number) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
  },

  easeInCubic(t: number) {
    return t * t * t
  },

  easeOutCubic(t: number) {
    return --t * t * t + 1 // eslint-disable-line no-plusplus, no-param-reassign
  },

  easeInOutCubic(t: number) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  },

  easeInQuart(t: number) {
    return t * t * t * t
  },

  easeOutQuart(t: number) {
    return 1 - --t * t * t * t // eslint-disable-line no-plusplus, no-param-reassign
  },

  easeInOutQuart(t: number) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t // eslint-disable-line no-plusplus, no-param-reassign
  },

  easeInQuint(t: number) {
    return t * t * t * t * t
  },

  easeOutQuint(t: number) {
    return 1 + --t * t * t * t * t // eslint-disable-line no-plusplus, no-param-reassign
  },

  easeInOutQuint(t: number) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t // eslint-disable-line no-plusplus, no-param-reassign
  },
}

export default easings
